import { type ButtonProps, createTheme, type MantineTheme } from "@mantine/core";

export const theme = createTheme({
  fontFamily: "Estedad, sans-serif",
  primaryColor: "primary",
  primaryShade: 6,
  fontSizes: {
    xs: "11px",
    sm: "12px",
    md: "13px",
    lg: "15px",
    xl: "18px",
  },
  colors: {
    primary: [
      "#f4f3f9",
      "#e9e7f4",
      "#dedaee",
      "#d3cee8",
      "#c8c2e2",
      "#654ea3",
      "#5b4694",
      "#523f86",
      "#493878",
      "#40306a",
    ],
    secondary: [
      "#e7e9ec",
      "#ced3d9",
      "#b6bdc6",
      "#9da7b3",
      "#8591a0",
      "#6c7b8d",
      "#54657a",
      "#3b4f67",
      "#273d58",
      "#0a2341",
    ],
    neutral: [
      "#ffffff",
      "#f5f5f5",
      "#e6e6e6",
      "#cccccc",
      "#999999",
      "#808080",
      "#6c6c6c",
      "#4d4d4d",
      "#333333",
      "#1a1a1a",
    ],
    error: [
      "#fbeaea",
      "#f6d6d6",
      "#f0b8b8",
      "#e88a8a",
      "#df5c5c",
      "#d33030",
      "#b82727",
      "#9c1f1f",
      "#7f1919",
      "#5e1212",
      "#ef4444",
    ],
    success: [
      "#dcfce7",
      "#bbf7d0",
      "#86efac",
      "#4ade80",
      "#22c55e",
      "#16a34a",
      "#15803d",
      "#166534",
      "#14532d",
      "#0f3c22",
    ],
  },
  shadows: {
    sm: "0px 6px 6px -6px #00000029",
    md: "0px 12px 12px -6px #00000029",
    lg: "0px 8px 24px -6px #00000029",
    xl: "0px 0px 32px -8px #0000001f, 0px 32px 32px -8px #00000014",
  },
  components: {
    Badge: {
      defaultProps: {
        p: "sm",
        radius: "md",
      },
    },
    Button: {
      styles: (theme: MantineTheme, params: ButtonProps) => ({
        root: {
          ...(params.variant === "outline" && {
            borderWidth: "1.5px",
            borderColor: theme.colors.secondary?.[9],
            color: theme.colors.secondary?.[9],
          }),
        },
      }),
    },
    Input: {
      styles: {
        input: {
          fontSize: "sm",
        },
      },
    },
    InputWrapper: {
      defaultProps: {
        labelProps: {
          mb: "xs",
          fw: "500",
          fz: "xs",
        },
        errorProps: {
          fz: "xs",
        },
      },
    },
  },
});
